/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/core/Tooltip';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import InformationIcon from 'assets/icons/information';
import { ReactComponent as X } from '../icons/X.svg';
import { ReactComponent as Eye } from '../icons/Eye.svg';
import { ReactComponent as EyeSlashed } from '../icons/EyeSlashed.svg';

import commonStyles from '../common.cssmodule.css';
import styles from './style.cssmodule.css';

const Input = ({
  label,
  hint,
  error,
  fullWidth,
  dotColor,
  tooltipId,
  inputIcon,
  value,
  showCharactersCounter,
  disableButtons,
  ...inputProps
}) => {
  const isPassword = inputProps.type === 'password';
  const [hideValue, setHideValue] = useState(isPassword);

  const { name, required } = inputProps;

  const inputRef = useRef(null);

  // Handle focus on input if click inside the container but not on the input
  const handleContainerClick = (e) => {
    if (
      inputRef.current
      && !e.target.closest('button')
      && e.target !== inputRef.current
    ) {
      inputRef.current.focus();
    }
  };

  const charactersCounter = inputProps.value ? inputProps.maxLength - inputProps.value.length : `Max. ${inputProps.maxLength}`;

  let EyeIcon = null;

  if (inputProps.type === 'password') {
    const handleHideValue = () => setHideValue((x) => !x);
    EyeIcon = hideValue ? <Eye className={styles.hideIcon} onClick={handleHideValue} /> : <EyeSlashed className={styles.hideIcon} onClick={handleHideValue} />;
  }

  const DotColor = dotColor && <div className={commonStyles.dotColor} style={{ backgroundColor: dotColor }} />;
  const Label = label ? <label htmlFor={name} className={commonStyles.label}>{`${label}${required ? ' *' : ''}`}</label> : null;

  const InformationTooltip = tooltipId && (
    <Tooltip content={(<LocalizedMessage id={tooltipId} />)}>
      <InformationIcon className={commonStyles.infoIcon} />
    </Tooltip>
  );
  const CharactersCounter = (inputProps.maxLength && !inputProps.disabled) && <span className={commonStyles.charactersCounter}>{charactersCounter}</span>;

  const Hint = (!error && hint)
    ? (
      <span className={commonStyles.hint}>
        {hint}
      </span>
    ) : null;

  const ErrorMessage = (
    <span className={commonStyles.error} id={error ? `${name}-error` : undefined}>
      {error ? (
        <React.Fragment>
          <X />
          <span>{error}</span>
        </React.Fragment>
      ) : null}
    </span>
  );

  return (
    <div className={commonStyles.field} style={{ gridColumn: fullWidth ? '1 / -1' : 'span 1' }}>
      {label && (
      <div className={commonStyles.fieldHeader}>
        {DotColor}
        {Label}
        {InformationTooltip}
        {showCharactersCounter && CharactersCounter}
      </div>
      )}
      <div className={commonStyles.inputContainer} onClick={handleContainerClick} style={{ cursor: 'text' }}>
        {inputIcon}
        <input
          {...inputProps}
          value={value || ''}
          type={(isPassword && !hideValue) ? 'text' : inputProps.type}
          ref={inputRef}
        />
        {EyeIcon}
      </div>
      {Hint}
      {ErrorMessage}
    </div>
  );
};
Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  hint: PropTypes.string,
  fullWidth: PropTypes.bool,
  dotColor: PropTypes.string,
  tooltipId: PropTypes.string,
  maxLength: PropTypes.number,
  inputIcon: PropTypes.node,
  showCharactersCounter: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};
Input.defaultProps = {
  type: 'text',
  label: null,
  fullWidth: false,
  error: null,
  maxLength: null,
  tooltipId: null,
  hint: null,
  dotColor: null,
  showCharactersCounter: true,
  placeholder: '',
  inputIcon: null,
  value: '',
  required: false,
  onChange: () => {},
};

export default Input;



// WEBPACK FOOTER //
// ./components/inputs/Input/Input.jsx